import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { TriangleAlert } from "lucide-react";

interface DataTableCellErrorTooltipProps {
  message: string;
}

export const DataTableCellErrorTooltip = ({
  message,
}: DataTableCellErrorTooltipProps) => {
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            tabIndex={0}
            className="shrink-0 rounded-sm p-0.5 text-red-600 outline-none hover:text-red-700 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1"
            aria-label={message}
          >
            <TriangleAlert className="h-3.5 w-3.5" aria-hidden />
          </button>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          align="center"
          className="max-w-xs text-left"
        >
          {message}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
